// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".toggle-report[data-v-41af5606] {\n  border-radius: 50px;\n}\n.ml-auto[data-v-41af5606] {\n  margin-left: auto;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
